var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"tree-map"}},[_c('apexchart',{attrs:{"type":"treemap","height":"350","options":_vm.chartOptions,"series":_vm.chartSeries}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }